<template>
  <div>
    <img v-if="currentPath!=='/login' && currentPath!=='/register'" :src="BottomImg" style="width:100%;" alt="">
    <div class="footer-title" style="color:#888; font-size:12px" v-html="LoginBrowse"></div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      LoginBrowse: sessionStorage.getItem('LoginBrowse') || '<p>浏览器使用建议：请使用谷歌、火狐浏览器或者IE10及以上的浏览器。</p>',
      BottomImg: sessionStorage.getItem('BottomImg') || '',
      currentPath: ''
    }
  },
  mounted() {
    this.currentPath = this.$route.path
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue